import app from 'flarum/forum/app';
import usernameHelper from 'flarum/common/helpers/username';
import Avatar from 'flarum/common/components/Avatar';
import highlight from 'flarum/common/helpers/highlight';
import MentionableModel from './MentionableModel';
import getCleanDisplayName, { shouldUseOldFormat } from '../utils/getCleanDisplayName';
export default class UserMention extends MentionableModel {
  type() {
    return 'user';
  }
  initialResults() {
    return Array.from(app.store.all('users'));
  }

  /**
   * Automatically determines which mention syntax to be used based on the option in the
   * admin dashboard. Also performs display name clean-up automatically.
   *
   * @"Display name"#UserID or `@username`
   *
   * @example <caption>New display name syntax</caption>
   * // '@"user"#1'
   * forUser(User) // User is ID 1, display name is 'User'
   *
   * @example <caption>Using old syntax</caption>
   * // '@username'
   * forUser(user) // User's username is 'username'
   */
  replacement(user) {
    if (shouldUseOldFormat()) {
      const cleanText = getCleanDisplayName(user, false);
      return this.format.format(cleanText);
    }
    const cleanText = getCleanDisplayName(user);
    return this.format.format(cleanText, '', user.id());
  }
  suggestion(model, typed) {
    const username = usernameHelper(model, name => highlight(name, typed));
    return m('[', null, m(Avatar, {
      user: model
    }), username);
  }
  matches(model, typed) {
    if (!typed) return false;
    const names = [model.username(), model.displayName()];
    return names.some(name => name.toLowerCase().substr(0, typed.length) === typed);
  }
  maxStoreMatchedResults() {
    return null;
  }
  async search(typed) {
    return await app.store.find('users', {
      filter: {
        q: typed
      },
      page: {
        limit: 5
      }
    });
  }
  enabled() {
    return true;
  }
}
flarum.reg.add('flarum-mentions', 'forum/mentionables/UserMention', UserMention);